import React, { useEffect, useState } from "react";
import Api from "../api/Api";
import AdvancedList from "../controls/AdvancedList";
import SortButton from "../controls/SortButton";
import Page from "../layout/Page";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

export default function RequestList() {

	let navigate = useNavigate();
	const [cards, setCards] = useState(null);
	const [canCreate, setCanCreate] = useState([]);

	useEffect(() => {
		Api.put('requests/getrequests', null, response => {
			setCards(response.data.cards);
			setCanCreate(response.data.canCreate);
		});
	}, []);

	const actions = [];
	if (canCreate.length)
		actions.push(
			<div className="btn-group">
				<span className="btn btn-sm btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">{t.cardCreateNew}</span>
				<div className="dropdown-menu dropdown-menu-end">
					{canCreate.includes(1) && <Link to="/requests/new/1" className="dropdown-item">{t.cardTypeVendor}</Link>}
					{canCreate.includes(2) && <Link to="/requests/new/2" className="dropdown-item">{t.cardTypeCustomer}</Link>}
					{canCreate.includes(3) && <Link to="/requests/new/3" className="dropdown-item">{t.cardTypeEmployee}</Link>}
				</div>
			</div>);

	const types = {
		1: t.cardTypeVendor,
		2: t.cardTypeCustomer,
		3: t.cardTypeEmployee,
	}
	const states = {
		11: t.cardRequestAdd,
		12: t.cardRequestEdit,
		13: t.cardRequestDeactivate,
		14: t.cardRequestActivate,
	}
	const lastStates = {
		1: t.cardStateEditing,
		2: t.cardStateSent,
		3: t.cardStateRejected,
		4: t.cardStateDeleted,
		11: t.cardStateManagerApproved,
		21: t.cardStateComplianceApproved,
		22: t.cardStateQrviApproved,
		31: t.cardStateFinancialControllingApproved,
		32: t.cardStateFinancialDirecorApproved,
	}

	const renderHeader =
		<tr>
			<th width="140">{t.cardType}</th>
			<th width="100">{t.cardIdNumber}</th>
			<th>{t.cardName}</th>
			<th width="120">{t.cardCompliance}</th>
			<th width="70">{t.cardQrvi}</th>
			<th width="120">{t.cardRequest}</th>
			<th width="120">{t.cardRequestApproved}</th>
		</tr>

	const renderCells = (card) => [
		types[card.type],
		card.idNumber,
		card.name,
		card.compliance ? <i className="fa-solid fa-check mx-auto d-block"></i> : null,
		card.qrvi ? <i className="fa-solid fa-check mx-auto d-block"></i> : null,
		states[card.state],
		lastStates[card.lastState],
	]

	return (
		<Page title="cardRequestList" actions={actions}>
			<AdvancedList
				data={cards}
				header={renderHeader}
				renderCells={renderCells}
				onRowClick={(card) => navigate(`/requests/${card.id}`)}
				searchProperties={["idNumber", "name"]}
				name="requests"
			/>
		</Page>
	);
}